import React from "react"
import styles from "./about-content.module.css";
// import Image from "../Image/image";
import myImagePath from '../../images/mkamranhamid.jpg';

const interests = ['Reading tech blogs', 'Meeting new people', 'Traveling', 'Coffee', 'Volunteering', 'Helping juniors'];
const skills = [
    'Javascript', 'Typescript', 'React', 'Angular', 'Redux', 'Mobx', 'Rxjs', 'Node.js', 'MongoDB', 'SQL',
    'Firebase', 'Ionic', 'React-Native', 'Continuous Integration'
];

const Chip = ({ data }) => (
    <div className={`${styles.skillOutline}`}>
        {data}
    </div>
)

export const Chips = ({ data }) => (
    <div className={`${styles.skillsContainer}`}>
        {data.map((datum, ind) => (<Chip data={datum} key={datum + ind} />))}
    </div>
)

const AboutContent = () => {
    return (
        <div className="content clear">
            <div className={`${styles.section50} br1`}>
                <div className={`${styles.leftSectionContainer}`}>
                    <div className={`${styles.leftSection}`}>
                        {/* <Image name="simpson.jpg" /> */}
                        <img src={myImagePath} alt="mkamranhamid" />
                    </div>
                </div>
            </div>
            <div className={`${styles.section50} gray`}>
                <div className="text-container">
                    <h2 className="underline">Introduction</h2>
                    <p className={`${styles.text}`}>
                        I’m a full-stack javascript engineer having 5 years of experience working on the
                        web, servers and hybrid mobile apps.
                    </p>
                    <ul className={`${styles.text}`}>
                        <li>
                            I have experience of working with all the modern frontend technologies like React,
                            Angular, Ionic and React-native using Typescript and Rxjs also state management tools
                            like Redux and Mobx.
                        </li>
                        <li>
                            I have experience of working with startups mostly and I really love it! Because 
                            when you’re working with startups you get a chance to wear different hats like 
                            frontend, backend and DevOps.
                        </li>
                        <li>
                            Lead team of engineers and designers. Ensure the team meets overall development 
                            goals keeping in mind milestones and deadlines are met.
                        </li>
                        <li>
                            I do open source contributions, write blogs and provide mentorship services for 
                            free because I believe that you have got to give back to society somehow and for 
                            a developer, this is the way to contribute also I get to learn new things too.
                        </li>
                        <li>
                            I am able to work highly effectively in an Agile environment with excellent 
                            interpersonal and communication skills.
                        </li>
                        <li>
                            At work, besides wearing a full-stack hat, I like to share my knowledge with 
                            colleagues through technical sessions on programming related topics.
                        </li>
                    </ul>
                    {/* <h4>
                        Currently, I'm working at Progstream as a Senior Developer.  It's one of the leading
                        software companies in Finland where I am responsible for full lifecycle development
                        of next-generation software, from initial requirement gathering to design, coding,
                        testing, documentation, and implementation.
                    </h4>
                    <br />
                    <h4>
                        At Progstream I've trained many interns and junior developer under my
                        supervision. I've also worked on development process and made agile a priority. In
                        addition, I created a CI/CD pipeline for smooth development flow.
                    </h4> */}
                    {/* <h4>
                    I'm a full stack MEAN/MERN Stack web/mobile app developer with 4+ years of developing
                    experience. I am able to work highly effectively in an Agile environment with excellent
                    interpersonal and communication skills. I am familiar with all phases of the software
                    development lifecycle.
                    I possess the ability to learn new languages and technologies quickly and rapidly I can come to speed and develop powerful application
                </h4> */}

                </div>
                <div className={`${styles.skills}`}>
                    <h2 className="underline">Skills</h2>
                    <div className="content">
                        <Chips data={skills} />
                    </div>
                </div>
                <div className={`${styles.interest}`}>
                    <h2 className="underline">Interests</h2>
                    <div className="content">
                        <Chips data={interests} />
                    </div>
                </div>
            </div>
        </div >
    )
}
export default AboutContent
